/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import { ModalHeader } from "./common";
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'modal';

/**
 * This is the component description.
 */
const Modal = ({
  id,
  className: userClassName,
  style,
  children,
  title,
  color,
  close
  // ...otherProps
}) => /*#__PURE__*/React.createElement("div", {
  id: id,
  className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
  style: style
  // {...otherProps}
}, /*#__PURE__*/React.createElement(ModalHeader, {
  title: title,
  close: close,
  color: color
}), /*#__PURE__*/React.createElement("div", {
  className: "modal-body"
}, children));
Modal.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   *  The children JSX
   */
  children: PropTypes.node,
  /**
   *  The title to pass to the header
   */
  title: PropTypes.string.isRequired,
  /**
   *  The color for the header button
   */
  color: PropTypes.string,
  /**
   *  The function to run upon closing the modal, if any
   */
  close: PropTypes.func
};
Modal.defaultProps = {
  color: 'heading'
};
export default Modal;